"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSQSEvent = void 0;
const uuid_1 = require("uuid");
/** returns a sqs event with ONE record with its body as the stringified version of payload object */
const getSQSEvent = ({ payload, eventParams, SQSMessageAttributes }) => {
    const recordPayloads = payload instanceof Array ? payload : [payload];
    const recordTemplate = {
        messageId: (0, uuid_1.v4)(),
        receiptHandle: 'r',
        body: '',
        attributes: {},
        messageAttributes: {},
        md5OfBody: '17',
        eventSource: 'aws:sqs',
        eventSourceARN: eventParams.eventSourceARN ?? 'arn:aws:sqs:ap-southeast-2:mockAccountId:mockEventSource',
        awsRegion: 'ap-southeast-2',
    };
    const template = {
        Records: [],
    };
    for (let recordPayload of recordPayloads) {
        const record = { ...recordTemplate };
        record.body = JSON.stringify(recordPayload);
        record.messageAttributes = SQSMessageAttributes ?? {};
        template.Records.push(record);
    }
    return template;
};
exports.getSQSEvent = getSQSEvent;
